<script>
import { mapGetters, mapActions } from "vuex";

import AdminAppShowDetail from "~/src/components/AdminAppShowDetail.vue";

export default {
  components: {
    AdminAppShowDetail,
  },

  props: {
    isReadonly: {
      type: Boolean,
      default: () => false,
    },
  },

  data: () => ({
    isLoading: false,

    isValid: false,
  }),

  computed: {
    ...mapGetters("admin-contract2024", ["GET_APPLICATION"]),
    application: (vm) => vm.GET_APPLICATION,
  },

  watch: {
    application: {
      immediate: true,
      handler(val) {
        if (val && val.paymentComment == null) {
          this.$set(val, "paymentComment", "");
        }
      },
    },
  },

  methods: {
    ...mapActions("admin-contract2024", [
      "INIT_APPLICATION",
      "SET_APPLICATION",
      "SAVE_APPLICATION_PAYMENT",
    ]),

    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },

    onChangeApp() {
      this.$nextTick(() => {
        this.SET_APPLICATION(this.application);
      });
    },

    onSend() {
      this.isValid = true;
      this.$refs.form.validate();
      this.$nextTick(() => {
        const el = document.querySelector(".error--text");

        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        } else {
          this.SAVE_APPLICATION_PAYMENT(this.application).then((status) => {
            if (status) {
              window.location.reload();
            }
          });
        }
      });
    },
  },
};
</script>

<template>
  <v-form
    :readonly="isReadonly"
    @submit.prevent="() => false"
    ref="form"
    lazy-validation
  >
    <div class="section-header">{{ $t("Contract Paid Information") }}</div>
    <div class="py-13 px-6">
      <div class="row">
        <div class="cols-12 col-md-5">
          <div>
            <admin-app-show-detail :title="$t('Kontrakt tulov miqdor')" />
            <admin-app-show-detail
              class="pt-4"
              :title="$t('Kontract summasi')"
              money :text="application.totalSumma"
            />
            <admin-app-show-detail
              class="pt-4"
              :title="$t('Tolangan summasi')"
              money :text="application.totalPaidSumma"
            />
            <admin-app-show-detail
              class="pt-4"
              :title="$t('Qoldiq')"
              money :text="application.totalOstatok"
            />
            <br />
            <div class="form-label">
              {{ $t("Paid Date") }} <span v-text="'*'" />
            </div>
            <v-text-field
              autocomplete="off"
              @blur="onChangeApp"
              v-model="application.paymentDate"
              dense
              outlined
              v-inputmask="$masks.date"
              required
              :rules="[$rules.required, $rules.date]"
            />
            <div class="form-label">
              {{ $t("To`lamoqchi bo'lgan Summa") }} <span v-text="'*'" />
            </div>
            <v-text-field
              autocomplete="off"
              @blur="onChangeApp"
              v-model="application.currentPayment"
              dense
              outlined
              required
              :rules="[$rules.required]"
              style="text-align: left"
            />
            <div class="form-label">
              {{ $t("Kommentariya") }}
            </div>
            <v-text-field
              autocomplete="off"
              @blur="onChangeApp"
              v-model="application.paymentComment"
              dense
              outlined
              style="text-align: left"
            />
          </div>
        </div>

        <div v-if="$vuetify.breakpoint.mdAndUp" class="col-2" />

        <div class="cols-12 col-md-5">
          <div>
            <admin-app-show-detail :title="$t('Guruh va tulov')" />
            <admin-app-show-detail
              class="pt-4"
              :title="$t('Guruh kodi')"
              :text="application.groupCode"
            />
            <div class="form-label">
              {{ $t("Payments Info") }}
              <div
                v-for="(item, index) in application.paymentList"
                :key="index"
                class="-text"
                v-text="
                  `${index + 1}. ${formatDate(item.datePayment)}-da ${
                    item.paid
                  } so'm${item.comment ? ' — ' + item.comment : ''}`
                "
              />
              <div v-if="!application.paymentList.length">—</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div align="center" class="col-12">
        <v-btn :disabled="isReadonly" @click="onSend" color="accent">
          {{ $t("Save") }}
        </v-btn>
      </div>
    </div>
  </v-form>
</template>

<style lang="scss" scoped>
.section-header {
  background: rgb(0, 150, 219);
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.25em;
  color: white;
  padding: 5px;
}

.form-label {
  font-weight: 500;
  margin-bottom: 8px;

  span {
    padding-left: 2px;
    color: red;
  }
}

.review-msg {
  position: absolute;
  top: -26px;
}
</style>
